<template>
  <label class="cn-checkbox">
    <input
      id=""
      v-model="valueLocal"
      type="checkbox"
      name=""
      :value="checkboxValue"
    />
    <slot />
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  modelValue?: boolean | Array<any>;
  checkboxValue?: number;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  checkboxValue: undefined,
});
const emit = defineEmits<{
  (e: 'update:modelValue' | 'change', data: boolean | Array<any>): void;
}>();

const valueLocal = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);

    emit('change', newValue);
  },
});
</script>

<style lang="scss">
.cn-checkbox {
  --ab-canyon-checkbox-color-accent: var(--ab-canyon-color-accent-4);
  --ab-canyon-checkbox-color-text: var(--ab-canyon-color-dark);
  --ab-canyon-checkbox-color-box-shadow-offset: var(--ab-canyon-color-light);
  color: var(--ab-canyon-checkbox-color-text);

  input {
    margin-right: var(--size-xs);
    border-radius: 0.125rem;
    border-width: 2px;
    color: var(--ab-canyon-checkbox-color-accent);
    &:focus {
      outline: none;
      box-shadow:
        0 0 0 1px var(--ab-canyon-checkbox-color-box-shadow-offset),
        0 0 0 2px
          color-mix(
            in srgb,
            var(--ab-canyon-checkbox-color-accent),
            transparent 50%
          );
    }
  }
}
</style>
